import React from 'react';

import { Flex } from '@adsk/alloy-react-box';

import { ACTIVITY_VARIANTS } from '../../../../../../constants';
import { Task } from '../../../../types';
import PlanTaskTitle from '../../../PlanTaskTitle/PlanTaskTitle';
import TaskConnectedIcon from '../../../TaskConnectedIcon/TaskConnectedIcon';
import TaskMilestoneIcon from '../../../TaskMilestoneIcon/TaskMilestoneIcon';

interface PlanTaskEntityActivityCardTitleProps {
  task: Task;
  variant?: typeof ACTIVITY_VARIANTS.ADDED | typeof ACTIVITY_VARIANTS.REMOVED;
}
const PlanTaskEntityActivityCardTitle = ({
  task,
  variant,
}: PlanTaskEntityActivityCardTitleProps) => (
  <Flex alignItems="center" style={{ gap: '8px' }}>
    {task.activityUniqueId && <TaskConnectedIcon />}
    {task.type === 'MILESTONE' && <TaskMilestoneIcon />}
    <PlanTaskTitle
      task={task}
      disabled={variant === ACTIVITY_VARIANTS.REMOVED}
      linkEnabled
    />
  </Flex>
);

export default PlanTaskEntityActivityCardTitle;
